import { render, staticRenderFns } from "./meta_data_add.vue?vue&type=template&id=9f73fc70"
import script from "./meta_data_add.vue?vue&type=script&lang=js"
export * from "./meta_data_add.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\pinmingproject\\suppervision-manager-ui-huangshi\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9f73fc70')) {
      api.createRecord('9f73fc70', component.options)
    } else {
      api.reload('9f73fc70', component.options)
    }
    module.hot.accept("./meta_data_add.vue?vue&type=template&id=9f73fc70", function () {
      api.rerender('9f73fc70', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/metadata/meta_data_add.vue"
export default component.exports